import { createSlice } from "@reduxjs/toolkit";
const initialPersonStaticState = { personStaticData: {} };

export const personStaticSlice = createSlice({
  name: "personStatic",
  initialState: initialPersonStaticState,
  reducers: {
    setPersonStaticState(state, action) {
      state.personStaticData = { ...state.personStaticData, ...action.payload };
    },
    resetPersonStaticState(state) {
     // state.personData = {};
     return initialPersonStaticState;
    }
  },
});
